<template>
    <router-link class="service-card" :to="url">
        <div class="service-card__image" :style="{backgroundImage: 'url(' + image + ')' }"></div>
        <div class="service-card__content">
            <h3 class="service-card__heading">{{title}}</h3>
            <p class="service-card__description">{{description}}</p>
            <span class="service-card__btn btn">Find Out More</span>
        </div>
    </router-link>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      required: true
    },
    image: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/partials/Card.vue